import { SSOResponseCode } from 'models/ssoTypes';
import Reate from 'reate';

interface SSOContext {
  signInStatus: boolean;
  ssoError?: SSOError;
}

interface SSOError {
  code: SSOResponseCode;
  message?: string;
}

export const authStateStore = new Reate({
  ssoContext: { signInStatus: false } as SSOContext,
  tenantAdminName: '',
  tenantAdminEmail: '',
  tenantId: '',
  tenantName: '',
  accessToken: '',
});
